// ./ui/ShareButton.js
import React from "react";
import { FaTwitter, FaTelegramPlane } from "react-icons/fa";

export default function ShareButton({ label, amount }) {
  const baseText = () => {
    if (label === "JACKPOT 💎") return `💎 I just hit the JACKPOT on Regret Roulette and won 1,000,000 $REGRET. Do you feel lucky?`;
    if (label === "Double Prize 🔁") return `Doubled my prize on Regret Roulette! Regret never felt this good.`;
    if (label === "Free Spin 🎉") return `The wheel gave me a second chance. Free spin on Regret Roulette!`;
    if (label === "Mystery 🪄" && amount) return `I just uncovered a mystery and won ${amount.toLocaleString()} $REGRET on Regret Roulette!`;
    if (label === "You Lose ❌") return `I spun the Regret Roulette and… well, I lost. But do I regret it? Yes.`;
    if (label === "Tax the wallet 💸") return `They taxed my spin on Regret Roulette. Capitalism wins again.`;
    if (label === "Regret Mirror 🪞") return `The wheel made me look at myself. I spun Regret Roulette and saw... regret.`;
    if (label?.includes("Redemption")) return `The wheel felt sorry for me. I got a Redemption spin and won ${amount?.toLocaleString()} $REGRET! #SecondChances`;

    if (amount) return `I just won ${amount.toLocaleString()} $REGRET on Regret Roulette! Can you beat my luck?`;
    return `I just played Regret Roulette! Can you beat my spin?`;
  };

  const url = "https://regretroulette.io"; // ← Pas dit aan als je live bent
  const twitterHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(baseText())}&url=${encodeURIComponent(url)}`;
  const telegramHref = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(baseText())}`;

  return (
    <div className="flex flex-col items-center gap-2 mt-4">
      <div className="flex justify-center gap-4">
        <a
          href={twitterHref}
          target="_blank"
          rel="noopener noreferrer"
          title="Share on Twitter"
          className="text-cyan-400 hover:text-cyan-300 text-2xl"
        >
          <FaTwitter />
        </a>
        <a
          href={telegramHref}
          target="_blank"
          rel="noopener noreferrer"
          title="Share on Telegram"
          className="text-cyan-400 hover:text-cyan-300 text-2xl"
        >
          <FaTelegramPlane />
        </a>
      </div>
      <p className="text-xs text-yellow-400 italic text-center max-w-xs">
        Every month, one player who shared their spin gets a mystery airdrop. No guarantees. Just hope. 🎁
      </p>
    </div>
  );
}
